// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Zr","modify_order":"as","modify_order_header":"bs","product_details_form_wrapper":"cs","c_wrapper":"es","save_button":"fs","title":"gs","modify_order_title_wrapper":"hs","note":"is","buttons_wrapper":"js"};
    if(module.hot) {
      // 1713809675640
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  